<template>

	<div class="portlet box green">

		<div class="portlet-title">

			<div class="caption">
				<i class="fa fa-heartbeat" aria-hidden="true"></i>
				<span v-translate>Medicação eventual</span>
			</div>

		</div>

		<div class="portlet-body">

			<form v-on:submit.prevent="addEventualMedicineItem" role="form">

				<div class="row">

					<div class="form-group col-md-3 col-xs-3" :class="{ 'has-error': errors.has('medicine-time') }">
						<label class="control-label" for="medicine-time" v-translate>Horário</label>
						<input type="text" id="medicine-time" name="medicine-time" v-mask="'##:##'" class="form-control" placeholder="Exemplo: 16:00" @change="completionStatus(false)" v-model="medicine.time" v-validate="{ rules: { required: true, regex: /([01]\d|2[0-3]):([0-5]\d)/} }">
					</div>

					<div class="form-group col-md-6 col-xs-6" :class="{ 'has-error': errors.has('medicine-medicine') }">
						<label class="control-label" for="medicine-medicine" v-translate>Medicação</label>
						<input type="text" class="form-control" id="medicine-medicine" name="medicine-medicine" placeholder="Medicação" @change="completionStatus(medicine)" v-model="medicine.medicine" v-validate="'required'">
					</div>

					<div class="form-group col-md-3 col-xs-3" :class="{ 'has-error': errors.has('medicine-dosage') }">
						<label class="control-label" for="medicine-dosage" v-translate>Dosagem</label>
						<input type="text" class="form-control" id="medicine-dosage" name="medicine-dosage" placeholder="Dosagem" @change="completionStatus(medicine)" v-model="medicine.dosage" v-validate="'required'">
					</div>

					<div class="form-group col-md-9 col-xs-12" :class="{ 'has-error': errors.has('medicine-reason') }">

						<label class="control-label" for="medicine-reason" v-translate>Observações/Justificativas:</label>
						<textarea id="medicine-reason" name="medicine-reason" @change="completionStatus(medicine)" v-model="medicine.reason" class="form-control" rows="3" maxlength="1000" v-validate="'required'"></textarea>

					</div>

					<div class="col-md-3 col-xs-12">

						<button type="submit" class="btn btn-block green btn-add" :disabled="errors.items.length > 0" v-translate>
							Adicionar
						</button>

					</div>

				</div>

			</form>

			<hr v-if="eventualMedicines && eventualMedicines.length > 0">

			<div class="table-responsive" v-if="eventualMedicines && eventualMedicines.length > 0">

				<table class="table table-bordered table-striped table-hover m-b-0">
					<thead>
						<tr>
							<th v-translate>Horário</th>
							<th v-translate>Medicação</th>
							<th v-translate>Observações</th>
							<th v-translate>Ações</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(medicine, index) in eventualMedicines">
							<td>{{ medicine.time | date('HH:mm', true) }}</td>
							<td>{{ medicine.medicine }} - {{medicine.dosage }}</td>
							<td>{{ medicine.reason }}</td>
							<td>

								<button type="button" class="btn btn-info btn-xs" @click="editEventualMedicineItem(index)">
									<i class="fa fa-pencil" aria-hidden="true"></i>
								</button>

								<button type="button" class="btn btn-danger btn-xs" @click="deleteEventualMedicineItem(index)">
									<i class="fa fa-times" aria-hidden="true"></i>
								</button>

							</td>
						</tr>
					</tbody>
				</table>

			</div>

		</div>

	</div>

</template>

<script>

	import StudentEventualMedicine from './';
	export default StudentEventualMedicine;

</script>

<style lang="scss" scoped>

	.btn-add {
		margin-top: 24px;
	}

</style>



// WEBPACK FOOTER //
// main.vue?77ac3698